<template>
  <div class="card">
    <div class="delivery" @click="toDetail(complaint)">
      <div class="card-header">
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">产品大类</span>
            <span>:</span>
            <span class="info-value">{{ complaint.topCateName }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">月计划量</span>
            <span>:</span>
            <span class="info-value">{{ complaint.monthSalesQuantity }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">半月执行量</span>
            <span>:</span>
            <span class="info-value">{{ complaint.monthUseQuantity }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">月执行量</span>
            <span>:</span>
            <span class="info-value">{{ complaint.monthUseQuantity }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">半月执行率</span>
            <span>:</span>
            <span class="info-value"> {{ complaint.monthUseRatio }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">月执行率</span>
            <span>:</span>
            <span class="info-value">{{ complaint.monthUseRatio}}</span>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
// import orderApi from "@/request/orderApi";
export default {
  name: "QualificationCard",
  props: {
    // order: Object,
    complaint: Object
  },
  data() {
    return {
       qualificationList: []
    };
  },
  computed: {},
  methods: {
    toDetail(item) {
      this.$router.push({
        path:'/salePlanDetail',
        query:{
          id:item.id
        }
      });
    },
    
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';
.card {
  margin-top: 10px;
  background: #ffffff;
  padding: 12px 24px;
  font-size: 26px;
  border-radius: 20px;
  .card-header {
    // margin-bottom: 20px;
  }

  .card-header, .card-total, .card-info {
    padding: 12px 0;
  }

  .card-info, .card-total {
    color: #666666;
  }

  .info {
    line-height: 61px;

    .info-title {
      display: inline-block;
      min-width: 80px;
      text-align: justify;
      text-align-last: justify;
    }

    .info-value {
      margin-left: 16px;
    }

    .status {
      padding: 8px 12px;
      border: 1px solid black;
      border-radius: 10px;
    }
  }

  .color-red {
    color: #E12020;
  }

  .large {
    font-size: 36px;
  }

  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;

    .btn {
      min-width: 200px;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>